// extracted by mini-css-extract-plugin
export default {"VoiceRecogConatiner":"VoiceRecog_VoiceRecogConatiner__4MNlk","VoiceRecogComp":"VoiceRecog_VoiceRecogComp__mHyYO","RecognizedData":"VoiceRecog_RecognizedData__Cl6v9"};